export const buildProvenance = { "commitHash": "78a355ce9c76693680c0d512c7298e533d55ced6", "branchName": "refs/heads/release/2025.4", "buildDate": "2026-02-24T06:18:44.214Z", "version": "2025.4.10464" };
